import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';

export default function TicketSummaryPreview() {
  const { id } = useParams();
  const [opened, setOpened] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (opened) return;
    setOpened(true);

    api.get(`/tickets/${id}/summary-print`, { responseType: 'blob' })
      .then(res => {
        const blob = new Blob([res.data], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch(() => setError('Zusammenfassung konnte nicht geladen werden.'));
  }, [id, opened]);

  if (error) return <div style={{ padding: 40, color: 'red' }}>{error}</div>;
  return <div style={{ padding: 40 }}>Lade Zusammenfassung...</div>;
}
